import { ICommon, TenantStatus } from 'types/common';

export interface ITenant extends ICommon {
	projectID?: string;
	name: string;
	domain: string;
	createdTime?: number;
	selfProvisioning?: boolean;
	selfProvisioningDomains?: string[];
	status?: TenantStatus;
}

export interface ITenants {
	tenants?: Array<ITenant>;
	total: number;
}

export interface ITenantCreateResponse {
	tenant: ITenant;
}

export enum TenantSettings {
	details = 'details',
	sso = 'sso',
	mappings = 'mappings'
}
